import React, { useState } from "react";
import { Typography, message } from "antd";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import ReactPlayer from "react-player";
const { Text } = Typography;

const FilePreviewerCynter = ({ fileUrl, isReadyToRender = true }) => {
  const [hasError, setHasError] = useState(false);
  const [docViewerKey] = useState(Date.now());

  const fileName = fileUrl?.split("/")?.pop() || "Unknown File";
  const fileType = fileName?.split(".")?.pop()?.toUpperCase() || "N/A";

  const docs = [
    {
      uri: fileUrl,
      fileType: fileType.toLowerCase(),
      fileName,
    },
  ];
  const isVideo = ["MP4", "WEBM", "OGG"].includes(fileType);
  return (
    <div
      style={{
        width: "auto", // fixed preview width
        height: "auto", // fixed preview height
        border: "1px solid #ccc",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff", // make sure no black background
      }}
    >
      {!hasError && fileUrl && isReadyToRender ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden", // scroll only inside
          }}
        >
          {isVideo ? (
            <ReactPlayer src={fileUrl} controls width="100%" height="70%" />
          ) : (
            <DocViewer
              key={docViewerKey}
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
              onDocumentLoadFailed={() => {
                setHasError(true);
                message.error("Failed to load the document.");
              }}
            />
          )}
        </div>
      ) : (
        <Text type="secondary" style={{ padding: 16 }}>
          Loading preview...
        </Text>
      )}
    </div>
  );
};

export default FilePreviewerCynter;
